import { isNull, get } from "lodash"
import locales from "./../../../content.json"

const BOTTOM_LINE_LBS = 80
const TOP_LINE_LBS = 500
const BELOW_BOTTOM_LINE_LBS_MESSAGE = locales[window.userLang].goal_weight_warning_1
const ABOVE_TOP_LINE_LBS_MESSAGE = locales[window.userLang].goal_weight_warning_2

const BOTTOM_LINE_KG = 35
const TOP_LINE_KG = 230
const BELOW_BOTTOM_LINE_KG_MESSAGE = locales[window.userLang].goal_weight_warning_1
const ABOVE_TOP_LINE_KG_MESSAGE = locales[window.userLang].goal_weight_warning_2

export const checkIsValidLbsGoalWeight = data => {
    return validateGoalWeightLbsStep(get(data, ["goalWeight", "value"], "")) && !data.goalWeight.isValid
}

export const checkIsValidKgGoalWeight = data => {
    return validateGoalWeightKgStep(get(data, ["goalWeight", "value"], "")) && !data.goalWeight.isValid
}

export const checkIsChoosedGoalWeightType = (data, type) => {
    return get(data, ["goalWeight", "type"], null) === type
}

export const isFailureLbsValidation = data => {
    return !validateGoalWeightLbsStep(get(data, ["goalWeight", "value"], ""))
        && get(data, ["goalWeight", "validString"], "") !== getValidateLbsMessage(get(data, ["goalWeight", "value"], ""))
}

export const isFailureKgValidation = data => {
    return !validateGoalWeightKgStep(get(data, ["goalWeight", "value"], ""))
    && get(data, ["goalWeight", "validString"], "") !== getValidateKgMessage(get(data, ["goalWeight", "value"], ""))
}

export const validateGoalWeightKgStep = value => {
    return !isNull(value)
        ? value >= BOTTOM_LINE_KG && value <= TOP_LINE_KG
        : false
}

export const getValidateKgMessage = value => {
    let message = ""

    if (!isNull(value))
        if (value <= BOTTOM_LINE_KG)
            message = BELOW_BOTTOM_LINE_KG_MESSAGE
        else if (value >= TOP_LINE_KG)
            message = ABOVE_TOP_LINE_KG_MESSAGE

    return message
}

export const validateGoalWeightLbsStep = value => {
    return !isNull(value)
        ? value >= BOTTOM_LINE_LBS && value <= TOP_LINE_LBS
        : false
}

export const getValidateLbsMessage = value => {
    let message = ""

    if (!isNull(value))
        if (value <= BOTTOM_LINE_LBS)
            message = BELOW_BOTTOM_LINE_LBS_MESSAGE
        else if (value >= TOP_LINE_LBS)
            message = ABOVE_TOP_LINE_LBS_MESSAGE

    return message
}

export const goalWeightTypeData = {
    lbs: {
        value: "lbs",
        title: locales[window.userLang].weight_lbs,
    },
    kg: {
        value: "kg",
        title: locales[window.userLang].weight_kg,
    },
}